//
//
//
//
//
//
//
//
//
//

export default {
    name: "loadingPage",
    data() {
        return {}
    },
    methods: {},
    created() {
    }
}
